import React, { useState } from 'react';
import { Paper, Box, Typography, Grid, FormControlLabel, Checkbox, TextField, Collapse, Switch } from '@mui/material';

const ADDITIONAL_INCLUSIONS = [
    'Candle light dinner',
    'Room decoration',
    'Honeymoon Inclusion',
    'AC Cab',
    'Room Heater',
    'Birthday Cake Arrangement',
    'Additional Halfday/Fullday Sightseeings',
    'Beverages & Snacks'
];

const AdditionalInclusionsCard = ({ tripDetails, setTripDetails, handleOptionalExtraIncludeToggle }) => {
    const [isExpanded, setIsExpanded] = useState(true);

    const handleToggle = (name, checked) => {
        setTripDetails(prev => {
            const currentExtras = prev.optional_extras || [];
            let newExtras = [...currentExtras];
            const existingIndex = newExtras.findIndex(e => (e.name || '').toLowerCase().trim() === name.toLowerCase().trim());

            if (checked) {
                if (existingIndex < 0) {
                    newExtras.push({ name: name, price: 0, count: 1, include_in_cost: true });
                }
            } else {
                if (existingIndex >= 0) {
                    newExtras.splice(existingIndex, 1);
                }
            }

            return { ...prev, optional_extras: newExtras };
        });
    };

    const handlePriceChange = (name, price) => {
        setTripDetails(prev => {
            const currentExtras = prev.optional_extras || [];
            let newExtras = [...currentExtras];
            const existingIndex = newExtras.findIndex(e => (e.name || '').toLowerCase().trim() === name.toLowerCase().trim());

            if (existingIndex >= 0) {
                newExtras[existingIndex] = { ...newExtras[existingIndex], price: Number(price) };
            }

            return { ...prev, optional_extras: newExtras };
        });
    };

    return (
        <Paper sx={{ p: 3, mb: 3, borderRadius: 2, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', border: '1px solid #eee' }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                    mb: isExpanded ? 2 : 0,
                    transition: 'opacity 0.2s',
                    '&:hover': { opacity: 0.8 }
                }}
                onClick={() => setIsExpanded(!isExpanded)}
            >
                <Typography variant="h6" sx={{ fontWeight: 700, color: '#333' }}>
                    Additional Inclusions & Charges
                </Typography>
            </Box>
            <Collapse in={isExpanded}>
                <Grid container spacing={2}>
                    {ADDITIONAL_INCLUSIONS.map((inclusion) => {
                        const selectedExtra = (tripDetails.optional_extras || []).find(e => (e.name || '').toLowerCase().trim() === inclusion.toLowerCase().trim());
                        const isSelected = !!selectedExtra;

                        return (
                            <Grid item xs={12} sm={6} md={3} key={inclusion}>
                                <Box sx={{ border: '1px solid #eee', p: 1, borderRadius: 1, height: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                size="small"
                                                checked={isSelected}
                                                onChange={(e) => handleToggle(inclusion, e.target.checked)}
                                            />
                                        }
                                        label={
                                            <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                                {inclusion}
                                            </Typography>
                                        }
                                    />
                                    {isSelected && (
                                        <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
                                            <TextField
                                                size="small"
                                                label="Charge (₹)"
                                                type="number"
                                                value={selectedExtra.price === 0 ? '' : selectedExtra.price}
                                                onChange={(e) => handlePriceChange(inclusion, e.target.value)}
                                                inputProps={{ min: 0 }}
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Switch 
                                                        size="small" 
                                                        checked={selectedExtra.include_in_cost !== false} 
                                                        onChange={(e) => handleOptionalExtraIncludeToggle && handleOptionalExtraIncludeToggle(inclusion, e.target.checked)}
                                                        color="primary"
                                                    />
                                                }
                                                label={<Typography variant="caption" sx={{ fontWeight: 600 }}>Include Cost</Typography>}
                                            />
                                        </Box>
                                    )}
                                </Box>
                            </Grid>
                        );
                    })}
                </Grid>
            </Collapse>
        </Paper>
    );
};

export default AdditionalInclusionsCard;
